function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import IconX from '~icons/bx/x';
import { contrastingTextColor, nameToHash, shouldTextBeLight, su, theme } from '@arc/frontend/ui-theme';
import { HighlightText } from './HighlightText';
import { HubTooltip } from './HubTooltip';
import { LineClamp } from './LineClamp';
function tagStyles({
  tagColor,
  size,
  disabled,
  global
}) {
  return /*#__PURE__*/css(global ? su.roundedMd : su.roundedFull, "display:inline-flex;align-items:center;justify-content:flex-start;max-width:100%;", {
    tiny: /*#__PURE__*/css(global ? su.roundedSm : su.roundedFull, su.textXs, "padding-left:0.5rem;padding-right:0.5rem;min-width:1rem;padding-bottom:0.5px;" + (process.env.NODE_ENV === "production" ? "" : ";label:tiny;")),
    medium: /*#__PURE__*/css(global ? su.roundedMd : su.roundedFull, su.textSm, "height:1.5rem;padding-left:0.75rem;padding-right:0.75rem;min-width:2rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:medium;")),
    clickable: /*#__PURE__*/css(su.textMd, "height:2rem;padding-left:0.75rem;padding-right:0.75rem;min-width:2rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:clickable;"))
  }[size], disabled && /*#__PURE__*/css({
    backgroundColor: theme.colors.input.disabledBackground,
    borderColor: theme.colors.input.disabledBorder,
    borderWidth: 1
  }, process.env.NODE_ENV === "production" ? "" : ";label:tagStyles;"), tagColor.toLocaleUpperCase() === '#FFFFFF' && /*#__PURE__*/css({
    borderColor: theme.colors.text.secondary,
    borderWidth: '1px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:tagStyles;"), process.env.NODE_ENV === "production" ? "" : ";label:tagStyles;");
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "une79m",
  styles: "display:flex;align-items:center;justify-content:center;width:2rem;height:2rem;margin-left:-0.25rem;margin-right:-0.75rem"
} : {
  name: "vwa4gd-Tag",
  styles: "display:flex;align-items:center;justify-content:center;width:2rem;height:2rem;margin-left:-0.25rem;margin-right:-0.75rem;label:Tag;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "14u8nkx",
  styles: "vertical-align:-0.125em"
} : {
  name: "6yx5y3-Tag",
  styles: "vertical-align:-0.125em;label:Tag;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function Tag({
  text,
  textStyles,
  color = nameToHash(text ?? ''),
  size = 'tiny',
  removable = false,
  searchTerm,
  disabled = false,
  readOnly = false,
  calloutText,
  global = false,
  ...restProps
}) {
  return <HubTooltip title={calloutText}>
			<div css={tagStyles({
      tagColor: color,
      size,
      disabled,
      global
    })} {...restProps}
    // Tag color is set on `style` so emotion doesn't create
    // a new class for every rendered tag color
    style={{
      background: color,
      color: contrastingTextColor(color)
    }}>
				<LineClamp css={textStyles} lines={1}>
					<HighlightText text={text} highlight={searchTerm} highlightColor={shouldTextBeLight(color) ? '#8d8633' : undefined} lineClamp />
				</LineClamp>
				{removable && !readOnly ? <div css={// Note: We assume that this icon is never shown when size != 'clickable'
      _ref}>
						<IconX css={_ref2} width={20} height={20} />
					</div> : null}
			</div>
		</HubTooltip>;
}